var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor-mobile-header-menu',{ref:"menu",staticClass:"editor-mobile-header-chat"},[_c('chat',{attrs:{"chat-type":"document","entity-id":_vm.document.id,"entity":_vm.document}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }